export default {
    data() {
        return {
            apiBase: 'https://ccb-server-staging.muluntech.com'
            //apiBase: 'http://cocobar-backend.local.com'
        };
    },
    methods: {}
}
